import styled from 'styled-components';

import { Skeleton } from '@gympass/yoga';

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  & + & {
    padding-top: ${({ theme }) => theme.yoga.spacing.small}px;
    margin-top: ${({ theme }) => theme.yoga.spacing.small}px;
    border-top: 1px solid ${({ theme }) => theme.yoga.colors.light};
  }
`;

export const FirstLine = styled(Skeleton).attrs({
  width: 0,
  height: 20,
  type: 'rectangular',
})`
  width: 100%;
`;

export const SecondLine = styled(Skeleton).attrs({
  width: 0,
  height: 24,
  type: 'rectangular',
})`
  margin-top: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  width: 100%;
`;
